import { render, staticRenderFns } from "./UploadPage.vue?vue&type=template&id=39c91f49&"
import script from "./UploadPage.vue?vue&type=script&lang=js&"
export * from "./UploadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports